var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 72,
    viewBox: "0 0 69 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6685 46.6444C53.2986 41.6904 56.1282 35.0633 56.1282 27.7819C56.1282 12.4384 43.5635 0 28.0641 0C12.5647 0 0 12.4384 0 27.7819C0 43.1255 12.5647 55.5638 28.0641 55.5638C33.5001 55.5638 38.5751 54.0338 42.8737 51.3851L62.089 70.4072C63.5398 71.8434 65.8766 71.8434 67.3274 70.4072C68.799 68.9503 68.799 66.5725 67.3274 65.1156L48.6685 46.6444ZM48.6444 27.7819C48.6444 39.0338 39.4303 48.1553 28.0641 48.1553C16.6979 48.1553 7.48376 39.0338 7.48376 27.7819C7.48376 16.53 16.6979 7.40851 28.0641 7.40851C39.4303 7.40851 48.6444 16.53 48.6444 27.7819Z",
    fill: "#0092C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.03c9803d25f78d58d66b3f2f80fe48e9.svg";
export { ForwardRef as ReactComponent };